import { StyledRow } from '@/shared/styles';
import { GradientBorderButton } from '../../../Button/GradientBorderButton';
import { U1Button } from '../../../Button/U1Button';
import { DatepickerFooterProps } from './DatepickerFooter.consts';
import { useTranslation } from 'react-i18next';

export const DatepickerFooter: React.FC<DatepickerFooterProps> = ({
  onClose,
  onSelect,
}: DatepickerFooterProps) => {
  const { t } = useTranslation();

  return (
    <StyledRow $width="100%" $gap={24}>
      <GradientBorderButton
        onClick={onClose}
        text={t('admin.datepicker.cancel')}
        $width="50%"
        $height="50px"
        $padding="0px"
      />
      <U1Button text={t('admin.datepicker.select')} $width="50%" onClick={onSelect} />
    </StyledRow>
  );
};
